import $ from 'jquery';
import { Loader } from '@googlemaps/js-api-loader';

const google = window.google = window.google ? window.google : {};
const scolicare_options = window.scolicare_options;
const $map_holder = document.getElementById( 'scolicare_map' );
const options = {
	apiKey: scolicare_options.maps_key,
	libraries: ['places'],
};
let map, popup, autocomplete;
let markers = [];

$( document ).on( 'click', '#locator .marker', function( e ) {
	if ( !! $map_holder ) {
		e.preventDefault();
	}
} );

( new Loader( options ) ).load().then( () => {
	if ( !! $map_holder ) {
		const mapOptions = {
			'scrollwheel': false,
			'mapTypeId': 'roadmap',
			'styles': scolicare_options.maps_style,
		};

		map   = new google.maps.Map( $map_holder, mapOptions );
		popup = new google.maps.InfoWindow();

		initMarkers( $( '#scolicare_markers' ).children() );
		updateMarkers();
	}

	const autoOptions = {
		types: ['address'],
	}

	autocomplete = new google.maps.places.Autocomplete( document.getElementById( 'alternate-address'), autoOptions );

	initAutocomplete();
} );


function initMarkers( list ) {
	const bounds = new google.maps.LatLngBounds();

	$.each( list, function( index ) {
		const position = addMarker( $( list[ index ] ) );

		bounds.extend( position );
	} );

	const center = markers.hasOwnProperty( 0 );

	if ( center ) {
		focusMarker( markers[0], 10 );
	} else {
		map.fitBounds( bounds );
	}
}


function addMarker( element ) {
	const marker = _addMarker( {
		lat: element.data( 'lat' ),
		lng: element.data( 'lng' ),
	}, element.data( 'html' ), element.data( 'id' ), element.data( 'category' ) );

	return marker.position;
}


function _addMarker( coords, html, id, category ) {
	let position = new google.maps.LatLng( coords.lat, coords.lng )
	let icon     = '/icons/' + category + '-marker.png'
	let marker   = new google.maps.Marker({ map, position, icon })

	marker.html = html;
	marker.id = id;

	marker.addListener( 'click', function() {
		updatePopup( marker );
	} );
	markers[ id ] = marker;

	$( document ).on( 'click', '#clinic-' + marker.id + ' .marker', function() {
		focusMarker( marker );
	} );

	return marker;
}


function updatePopup( marker ) {
	popup.setContent( marker.html );
	popup.setOptions( { maxWidth: 350 } );
	popup.open( map, marker );
}


function focusMarker( marker, number = 14 ) {
    $( 'html, body' ).animate( {
        scrollTop: $( "#scolicare_map" ).offset().top - ( $( '#masthead' ).outerHeight() || $( '#responsive-menu-pro-header-bar-items-container' ).outerHeight() )
    }, 800 );

	google.maps.event.trigger( marker, 'click' );
	map.setCenter( marker.getPosition() );
	map.setZoom( number );
}


function getCurrentLocation() {
	return new Promise( ( resolve, reject ) => {
		if ( navigator.geolocation ) {
			navigator.geolocation.getCurrentPosition( position => {
				resolve( {
					lat: position.coords.latitude,
					lng: position.coords.longitude,
				} );
			}, () => {
				reject( 'Browser Blocked Access' );
			} );
		} else {
			reject( 'Browser Not Supported' );
		}
	} );
}


function reloadLocation( coords, name = null ) {
	const url = new URL( window.location.origin + window.location.pathname );

	url.searchParams.append( 'latitude', coords.lat );
	url.searchParams.append( 'longitude', coords.lng );

	if ( name ) {
		url.searchParams.append( 'location', name );
	} else {
		name = 'Current Location';
	}

	name = `<a href="https://www.google.com/maps?q=${coords.lat},${coords.lng}" target="_blank">${name}</a>`;

	if ( !! $map_holder ) {
		if ( markers.hasOwnProperty( 0 ) ) {
			markers[0].setMap( null );
		}

		const center = _addMarker( coords, name, 0, 'Current-location' );

		focusMarker( center, 10 );
	}

	window.history.replaceState( null, null, url );
	FWP.refresh();
}


export function updateLocation( coords, name = null ) {
	if ( coords ) {
		reloadLocation( coords, name );
	} else {
		$( '.ajax-loading' ).removeClass( 'd-none' );
		getCurrentLocation().then( resolve => {
			reloadLocation( resolve );
			$( '.ajax-loading' ).addClass( 'd-none' );
		}, reject => {
			alert( `Unable to get current location: *${reject}*` );
			$( '.ajax-loading' ).addClass( 'd-none' );
		} );
	}
}


function initAutocomplete() {
	autocomplete.setFields( ['geometry', 'name'] );
	autocomplete.addListener( 'place_changed', setLocation );
}


function setLocation() {
	const place = autocomplete.getPlace();
	const location = place.geometry.location;

	updateLocation( {
		lat: location.lat(),
		lng: location.lng(),
	}, place.name );
}

export function updateMarkers() {
	if ( markers ) {
		markers.forEach( marker => {
			if ( 0 !== marker.id && ! document.getElementById( 'clinic-' + marker.id ) ) {
				marker.setMap( null );
			} else {
				marker.setMap( map )
			}
		} );
	}
}
